import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service/';
import messages, { ReturnShipmentStatusMessages } from './messages';

export const FULFILLMENT_STATUSES = 'fulfillmentStatuses';

export default {
  id: FULFILLMENT_STATUSES,
  type: OptionFormTypes.TYPE_CHECKLIST,
  filterValue: FULFILLMENT_STATUSES,
  allowsMultipleSelection: true,
  shouldHideActionButtons: true,
  displayName: (appliedFilters) => {
    const returnShipmentStatusFilters = appliedFilters.filter((filter) => filter.filterById === FULFILLMENT_STATUSES);
    if (returnShipmentStatusFilters.length === 0) {
      return <FormattedMessage {...messages.fulfillmentStatuses} />;
    }
    if (returnShipmentStatusFilters.length === 1) {
      const returnShipmentStatusKey = returnShipmentStatusFilters[0].criterionArgumentValue;
      return <FormattedMessage {...ReturnShipmentStatusMessages[returnShipmentStatusKey]} />;
    }
    return <FormattedMessage {...messages.multipleReturnShipmentStatuses} />;
  },
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
};
